<template>
    <div>
        <b-form-group
        class="input-group-var-ambit"
        label="Ambit:"
        label-size="sm"
        label-for="input-var-ambit"
        label-cols="4"
        >
            <b-form-select
            required
            size="sm"
            id="input-var-ambit"
            class="var-ambit"
            v-model="ambit"
            :options="opcionsAmbit"
            @input="onUpdateAmbit"
            >
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "VariableAmbit",
    props: {
        initialValue:{
            required: true,
        },
    },
    data(){
        return {
            codiVariable: "ambit",
            ambit: null,
            opcionsAmbit: [
                { value: "1", text: this.$t("fitxes.tipusAmbits.1") },
                { value: "2", text: this.$t("fitxes.tipusAmbits.2") },
            ],
        };
    },
    computed: {
        returnValue(){
            let r = {codi: this.codiVariable};
            if(this.ambit != null){
                r.valor = this.ambit
            }

            return r;
        },
    },
    methods: {
        onUpdateAmbit(newValue){
            this.$emit("ambit-seleccionat", newValue);
        },
    },
    mounted(){
        if(this.initialValue != null){
            this.ambit = this.initialValue.valor;
        } else{
            this.ambit = "1";
        }
    }
}
</script>
<style>
.var-ambit {
  width: 180px;
}
.input-group-var-ambit .col {
  text-align: left;
}
</style>